var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogoIcon = function SvgLogoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M40 0c22.055 0 40 17.944 40 40S62.055 80 40 80C17.942 80 0 62.056 0 40S17.943 0 40 0zm0 3.207c-20.294 0-36.803 16.51-36.803 36.794 0 20.281 16.51 36.792 36.802 36.792 20.293 0 36.804-16.51 36.804-36.792 0-20.283-16.51-36.794-36.804-36.794zm.21 3.076c18.707 0 33.926 15.22 33.926 33.926 0 18.708-15.22 33.927-33.927 33.927-18.708 0-33.926-15.22-33.926-33.927S21.5 6.283 40.209 6.283zm-4.118 10.094H31.14c-2.707 0-5.062 2.21-5.234 4.91l-2.449 38.519h9.877l1.003-15.793.26-4.099 7.272-4.812 3.783 2.24L44.53 54.54a4.952 4.952 0 0 0 4.94 5.266h4.601l1.764-27.211-13.923-8.563-.023-.04-.02.012-.02-.012-.025.04-6.481 4.15.75-11.805z"
  }))));
};
export default SvgLogoIcon;